var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isCroppable)?_c('a-image-cropper',{attrs:{"id":_vm.cropperId,"options":_vm.cropperOptions,"can-slide-zoom":false},on:{"data":_vm.onCrop}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }